var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"lbz-snackbar"},on:{"after-leave":_vm.fafterLeave}},[(_vm.vactive)?_c('div',{class:[
      'lbz-snackbar',
      _vm.valign && ("lbz-snackbar--" + _vm.valign),
      _vm.vstacked && 'lbz-is-stacked',
      _vm.vclass
    ]},[_c('div',{staticClass:"lbz-snackbar__container"},[_c('div',{staticClass:"lbz-snackbar__label",domProps:{"innerHTML":_vm._s(_vm.vlabel)}}),(_vm.vactionLabel)?_c('div',{staticClass:"lbz-snackbar__action"},[_c('lbz-button',{on:{"click":function($event){$event.stopPropagation();return _vm.factionClick($event)}}},[_vm._v(_vm._s(_vm.vactionLabel))])],1):_vm._e()])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }